var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertKeyExperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.668 39.4167H26.0013",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9836 28.4167H20.6836",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0013 24.75H18.668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 0.916687V3.66669",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.75H12.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.168 13.75H32.418",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4.99951L14.0838 7.33335",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9178 4.99951L30.584 7.33335",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7499 13.75C28.7671 12.9026 28.6129 12.0605 28.2966 11.2742C27.9802 10.4879 27.5082 9.77369 26.9089 9.17438C26.3096 8.57507 25.5953 8.10306 24.809 7.78669C24.0227 7.47032 23.1806 7.31611 22.3333 7.33333C21.4859 7.31611 20.6438 7.47032 19.8575 7.78669C19.0712 8.10306 18.3569 8.57507 17.7576 9.17438C17.1583 9.77369 16.6863 10.4879 16.3699 11.2742C16.0536 12.0605 15.8994 12.9026 15.9166 13.75C15.8139 14.8359 16.017 15.9288 16.503 16.9053C16.989 17.8818 17.7384 18.7028 18.6666 19.2757V20.1667C18.6666 20.4098 18.7632 20.6429 18.9351 20.8148C19.107 20.9868 19.3401 21.0833 19.5833 21.0833H25.0833C25.3264 21.0833 25.5595 20.9868 25.7314 20.8148C25.9033 20.6429 25.9999 20.4098 25.9999 20.1667V19.25C26.9269 18.6823 27.6761 17.8659 28.1622 16.8936C28.6484 15.9214 28.852 14.8322 28.7499 13.75Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0833 19.25H11.3333C10.8471 19.25 10.3808 19.4432 10.037 19.787C9.69315 20.1308 9.5 20.5971 9.5 21.0833V35.75H35.1667V21.0833C35.1667 20.5971 34.9735 20.1308 34.6297 19.787C34.2859 19.4432 33.8196 19.25 33.3333 19.25H30.5833",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3709 39.9538C39.6272 40.2102 39.8017 40.5369 39.8724 40.8924C39.9432 41.248 39.9068 41.6166 39.7681 41.9515C39.6294 42.2865 39.3945 42.5728 39.0931 42.7742C38.7916 42.9757 38.4373 43.0833 38.0747 43.0833H6.59271C6.23017 43.0833 5.87579 42.9757 5.57437 42.7742C5.27295 42.5728 5.03803 42.2865 4.8993 41.9515C4.76057 41.6166 4.72426 41.248 4.79497 40.8924C4.86568 40.5369 5.04022 40.2102 5.29654 39.9538L9.50038 35.75H35.167L39.3709 39.9538Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertKeyExperties);
export default __webpack_public_path__ + "static/media/expert_key_experties.6cafad37ff41c9f5b1af3318f69790fa.svg";
export { ForwardRef as ReactComponent };